export default __webpack_public_path__ + "static/media/sirolaser-vorher.006675e9.jpg";